import React, { Component } from 'react';
import { compose } from 'redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import { bookingFormInitialValues } from '../store/reducers';
import { setStep } from '../store/actions';
import { PAYMENT_METHOD_WITHOUT_PAYMENT } from '../constants'
import { getLabelForSelectedValue, formatPrice } from '../utils';
import { guestFields, companyFields } from '../enums/Guest';
import PaymentGateway from "../enums/PaymentGateway";
import StayType from '../enums/StayType';
import {getCountryLabel} from '../enums/countries';
import {
	getRoomPrice,
	getBoardBaseTotalPrice,
	getBoardBasesTotalPrice,
	getBoardBasesTotalBoardBasePrice,
	getNoOfSelectedBoardBase,
	getNoOfSelectedRooms,
	getSelectedExtraFees,
	getTotalExtraFeePrice,
	getTotalPricelistFees,
	isSelectedBoardBase,
	isSelectedExtraFee,
	isAtLeastOnePricelistFeeIncluded,
} from '../apiHelpers';
import GopayInline from "./GopayInline";
import PaymentMethodInput from './PaymentMethodInput';
import CheckboxInput from './CheckboxInput';
import T from './Translate';
import withLocalize from '../withLocalize';

class Step4 extends Component {

	componentWillMount() {
		this.props.dispatch(setStep(4));
	}

	render() {
		const {
			formValues,
			boardBases,
			extraFees,
			isPaymentGatewayEnabled,
			paymentGateway,
			error,
			isOnlineReservationWithoutPaymentEnabled,
			isAdvancePaymentRequired,
			advancePaymentPercentage,
			stornoInsurance,
			stornoInsurancePrice,
			totalPrice,
			priceToPay,
			noOfNights,
			terms,
			guestTypes,
			applyGuestTypeDiscountToBoardBase,
			translate: t,
			translatePropertyValue,
			apiRoomsResponse,
		} = this.props;

		const selectedBoardBasePrice = typeof formValues.boardBase === 'object'
			// Strava může být pro každoho hosta jiná
			? getBoardBasesTotalPrice(boardBases, formValues.boardBase, guestTypes, noOfNights, applyGuestTypeDiscountToBoardBase, formValues.currency)
			// Strava je pro všechny hosty stejná
			: (formValues.boardBase ? getBoardBaseTotalPrice(boardBases[formValues.boardBase], guestTypes, formValues.rooms, noOfNights, applyGuestTypeDiscountToBoardBase, formValues.currency) : null);
		const isAdvancePaymentOptional = advancePaymentPercentage < 100;
		const autoExtraFees = apiRoomsResponse ? apiRoomsResponse.extraFees : null;
		const pricelistFees = apiRoomsResponse ? apiRoomsResponse.pricelistFees : {};

		return (
			<section className="container">
				<fieldset className="fieldset">
					<legend><T id="Step4.stayFields" /></legend>

					<div className="fieldset__columns">
						<div className="overview-row">
							<label className="overview-row__label"><T id="DepartureArrival.arrival" /></label>
							<span className="overview-row__value">{formValues.arrival}</span>
						</div>

						<div className="overview-row">
							<label className="overview-row__label"><T id="DepartureArrival.departure" /></label>
							<span className="overview-row__value">{formValues.departure}</span>
						</div>

						<div className="overview-row">
							<label className="overview-row__label"><T id="DepartureArrival.noOfNights" /></label>
							<span className="overview-row__value">{noOfNights}</span>
						</div>

						<div className="overview-row">
							<label className="overview-row__label"><T id="Step2.stayType" /></label>
							<span className="overview-row__value">{t(getLabelForSelectedValue(StayType.getOptions(), formValues.stayType))}</span>
						</div>
					</div>
				</fieldset>

				<fieldset className="fieldset">
					<legend><T id="Step3.guestFields.title" /></legend>
					<div className="fieldset__columns">
						{guestFields.map((field, index) => (
							<div className="overview-row" key={`guestFields-${field.name}`}>
								<label className="overview-row__label">{t(field.label)}</label>
								<span className="overview-row__value" title={field.name === 'email' ? formValues[field.name] : ''}>{formValues[field.name]}</span>
							</div>
						))}
					</div>
				</fieldset>

				{formValues.isCompany === true &&
				<fieldset className="fieldset">
					<legend><T id="Step3.companyFields.title" /></legend>
					<div className="fieldset__columns">
						{companyFields.map((field, index) => (
							<div className="overview-row" key={`companyFields-${field.name}`}>
								<label className="overview-row__label">{t(field.label)}</label>
								<span className="overview-row__value">{field.name === 'companyCountry' ? getCountryLabel(formValues[field.name]) : formValues[field.name]}</span>
							</div>
						))}
					</div>
				</fieldset>
				}

				<fieldset className="fieldset">
					<legend><T id="Step4.roomsToReserve" /></legend>
					<div className="fieldset__columns">
						{/* Projdeme vybrané typy pokojů */}
						{Object.entries(formValues.rooms).map(([roomTypeId, rooms], roomTypeIndex) => {
							// A pro každý typ pokoje počet konkrétních pokojů
							return rooms.map((room, roomIndex) => (
								<div className="overview-row" key={`${roomTypeId}-${roomIndex}`}>
									<label className="overview-row__label">{room.name}</label>
									<span className="overview-row__value">{
										formatPrice(
											getRoomPrice(room, formValues.currency, room.guestTypes, guestTypes),
											formValues.currency
										)
									}, <T id="Step4.persons" data={{
										count: typeof room.guestTypes === 'object'
											? Object.keys(room.guestTypes).reduce((accumulator, guestTypeId) =>
												accumulator + room.guestTypes[guestTypeId], 0)
											: room.guestTypes
									}} /></span>
								</div>
							));
						})}
					</div>
				</fieldset>

				{(autoExtraFees.length > 0 || isSelectedExtraFee(formValues)) &&
				<fieldset className="fieldset">
					<legend><T id="Step4.extraFees" /></legend>
					<div className="fieldset__columns">
						{autoExtraFees.length > 0 && autoExtraFees.map(extraFee =>
						<div key={extraFee.id} className="overview-row">
							<label className="overview-row__label">
								{getNoOfSelectedRooms(formValues) > 1 &&
								<span>{getNoOfSelectedRooms(formValues)} &times; </span>
								}
								{translatePropertyValue(extraFee.name)}
							</label>
							<span className="overview-row__value">{getTotalExtraFeePrice(formValues.rooms, guestTypes, extraFee, true, noOfNights, formValues.currency)}</span>
						</div>
						)}
						{isSelectedExtraFee(formValues) && Object.entries(getSelectedExtraFees(formValues)).map(([extraFeeId, noOfSelectedExtraFee]) =>
						<div key={extraFeeId} className="overview-row">
							<label className="overview-row__label">
								{noOfSelectedExtraFee > 1 &&
								<span>{noOfSelectedExtraFee} &times; </span>
								}
								{translatePropertyValue(extraFees[extraFeeId].name)}
							</label>
							<span className="overview-row__value">{getTotalExtraFeePrice(formValues.rooms, guestTypes, extraFees[extraFeeId], false, noOfNights, formValues.currency)}</span>
						</div>
						)}
					</div>
				</fieldset>
				}

				{(isSelectedBoardBase(formValues) || isAtLeastOnePricelistFeeIncluded(pricelistFees)) &&
				<fieldset className="fieldset">
					<legend><T id="Step4.servicesAndOtherFees" /></legend>
					<div className="fieldset__columns">
						{isSelectedBoardBase(formValues) && typeof formValues.boardBase !== 'object' &&
						<div className="overview-row">
							<label className="overview-row__label">
								{getNoOfSelectedBoardBase(formValues, guestTypes) > 1 &&
								<span>{getNoOfSelectedBoardBase(formValues, guestTypes)} &times; </span>
								}
								{boardBases[formValues.boardBase].name}
							</label>
							<span className="overview-row__value">{selectedBoardBasePrice}</span>
						</div>
						}
						{isSelectedBoardBase(formValues) && typeof formValues.boardBase === 'object' && Object.keys(formValues.boardBase).map((boardBase, index) => getNoOfSelectedBoardBase(formValues, guestTypes, boardBase) < 1 ? '' :
						<div className="overview-row">
							<label className="overview-row__label">
								<span>{getNoOfSelectedBoardBase(formValues, guestTypes, boardBase)} &times; </span>
								{boardBases[boardBase].name}
							</label>
							<span className="overview-row__value">{getBoardBasesTotalBoardBasePrice(boardBases[boardBase], formValues.boardBase, guestTypes, noOfNights, applyGuestTypeDiscountToBoardBase, formValues.currency)}</span>
						</div>
						)}
						{isAtLeastOnePricelistFeeIncluded(pricelistFees) &&
						<div className="overview-row">
							<label className="overview-row__label">
								<T id="Rooms.RoomOffer.fees"/>
							</label>
							<span className="overview-row__value">
								{formatPrice(
									getTotalPricelistFees(pricelistFees, formValues.rooms, noOfNights, formValues.currency, formValues.stayType),
									formValues.currency
								)}
							</span>
						</div>
						}
						{formValues.stornoInsurance &&
						<div className="overview-row">
							<label className="overview-row__label">
								<T id="Step4.servicesAndOtherFees.stornoInsurance"/>
							</label>
							<span className="overview-row__value">
								{formatPrice(stornoInsurancePrice, formValues.currency)}
							</span>
						</div>
						}
					</div>
				</fieldset>
				}

				{isPaymentGatewayEnabled && paymentGateway &&
				<fieldset className="fieldset">
					<legend><T id="Step4.paymentType" /></legend>
					{isAdvancePaymentRequired &&
						<div className="alert-container"><T id="Step4.paymentType.advancePaymentAlert" data={{ advancePaymentPercentage }}/></div>
					}
					{!isAdvancePaymentRequired && isAdvancePaymentOptional && formValues.paymentMethod !== PAYMENT_METHOD_WITHOUT_PAYMENT &&
						<Field
							component={CheckboxInput}
							name="advancePaymentOnly"
							label={t('Step4.paymentType.advancePaymentOnly', { advancePaymentPercentage })}
							id="advancePaymentOnly"
						/>
					}
					{error && <div className="large-input-container__error large-input-container__error--radio">{error}</div>}
					<div className="payment-methods">
						{paymentGateway.instruments[formValues.currency.id].map((instrument, index) => (
							<Field
								component={PaymentMethodInput}
								name="paymentMethod"
								key={instrument.paymentInstrument}
								instrument={instrument}
								checked={formValues.paymentMethod === instrument.paymentInstrument}
							/>
						))}
						{isOnlineReservationWithoutPaymentEnabled &&
							<Field
								component={PaymentMethodInput}
								name="paymentMethod"
								instrument={{
									paymentInstrument: PAYMENT_METHOD_WITHOUT_PAYMENT,
									label: {
										cs: t('Step4.paymentType.paymentMethodWithoutPayment'),
									}
								}}
								checked={formValues.paymentMethod === PAYMENT_METHOD_WITHOUT_PAYMENT}
							/>
						}
					</div>
					{paymentGateway.slug === PaymentGateway.GOPAY && paymentGateway.scriptUrl !== null && <GopayInline src={paymentGateway.scriptUrl} />}
				</fieldset>
				}

				{isAtLeastOnePricelistFeeIncluded(pricelistFees, false) &&
				<fieldset className="fieldset fieldset--red-highlight">
					<T id="Step4.pricelistFeesNotIncluded"
					   data={{ fees: formatPrice(
							getTotalPricelistFees(
								pricelistFees, formValues.rooms, noOfNights, formValues.currency, formValues.stayType, false
							),
							formValues.currency)
					   }}
					/>
				</fieldset>
				}

				<fieldset className="fieldset fieldset--highlight">
					<div className="overview-row">
						<label className="overview-row__label overview-row__label--large"><T id="Step4.totalPrice" /></label>
						<span className="overview-row__value overview-row__value--large">{formatPrice(totalPrice, formValues.currency)}</span>
					</div>
					{formValues.advancePaymentOnly &&
					<div className="overview-row">
						<label className="overview-row__label overview-row__label--large"><T id="Step4.priceToPayNow" /></label>
						<span className="overview-row__value overview-row__value--large">{formatPrice(priceToPay, formValues.currency)}</span>
					</div>
					}
					<div className="fieldset__agree">
						<T id="Step4.agree" data={{ terms }} html={true} />
						{stornoInsurance &&
						<div className="fieldset__agree-storno-insurance">
							<Field
								component={CheckboxInput}
								name="stornoInsurance"
								id="stornoInsurance"
								label={t('Step4.stornoInsurance', { terms: stornoInsurance.vopUrl, price: formatPrice(stornoInsurancePrice, formValues.currency) }, true)}
							/>
						</div>
						}
					</div>
				</fieldset>

			</section>
		);
	}
}

export default compose(
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	connect((state) => ({
		formValues: getFormValues('bookingForm')(state),
		roomOffers: state.app.roomOffers,
		boardBases: state.app.boardBases,
		boardBaseOptions: state.app.boardBaseOptions,
		extraFees: state.app.extraFees,
		isPaymentGatewayEnabled: state.app.isPaymentGatewayEnabled,
		isOnlineReservationWithoutPaymentEnabled: state.app.isOnlineReservationWithoutPaymentEnabled,
		paymentGateway: state.app.paymentGateway,
		isAdvancePaymentRequired: state.app.isAdvancePaymentRequired,
		advancePaymentPercentage: state.app.advancePaymentPercentage,
		stornoInsurance: state.app.stornoInsurance,
		stornoInsurancePrice: state.app.stornoInsurancePrice,
		totalPrice: state.app.totalPrice,
		priceToPay: state.app.priceToPay,
		totalNoOfGuests: state.app.totalNoOfGuests,
		noOfNights: state.app.noOfNights,
		terms: state.app.terms,
		guestTypes: state.app.guestTypes,
		applyGuestTypeDiscountToBoardBase: state.app.applyGuestTypeDiscountToBoardBase,
		apiRoomsResponse: state.app.apiRoomsResponse,
	})),
	withLocalize,
)(Step4);



// WEBPACK FOOTER //
// ./src/components/Step4.jsx